export default [{
  path: '/btripplatform/main',
  name: 'btripplatform',
  component: resolve => require(['./index.vue'], resolve)
}
]



// WEBPACK FOOTER //
// ./src/views/btrip-platform/router.js